import axios from './axios';

export const PreRegister = {
  path: '/pre-register',
  async create_pre_register (data) {
    console.log(data);
    return await axios.post(`${this.path}`, data);
  },
}